import { PaletteMode } from "@mui/material";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import * as React from "react";
import getLPTheme from "./getLPTheme";
import AppAppBar from "./components/AppAppBar";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import LandingBackgroundCanvas from "./components/LandingBackgroundCanvas";

export default function LandingPage() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  const defaultTheme = React.useMemo(
    () => createTheme(getLPTheme(mode)),
    [mode]
  );

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Box
        sx={{
          bgcolor: "background.default",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <LandingBackgroundCanvas mode={mode} />
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
          <Hero />
          <Box>
            <Features />
            <Divider sx={{ maxWidth: 1200, mx: "auto", opacity: 0.55 }} />
            <Footer />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
